import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PincodeService {
  private apiCheckPincodeApiUrl = environment.checkPincodeApiUrl;

  constructor(private http: HttpClient) { }

  checkPincode(pincode: number): Observable<any> {
    return this.http.post(this.apiCheckPincodeApiUrl, {
      pincode: pincode
    });
  }

}
